const workshopRequestStatus = [
  {
    label: "Under Review",
    value: 0,
    className: "under_review",
    message:
      "The workshop request has been submitted and is currently under review by the team. This stage involves evaluating the content to ensure it meets platform standards.",
    messageAr:
      "تم استلام طلب ورشتك بنجاح، وهو الآن قيد المراجعة من قِبل فريقنا. نُجري حاليًّا التقييم اللازم لضمان توافق الورشة مع المعايير المعتمدة. سيتم إشعارك بنتيجة المراجعة خلال أيام العمل المقبلة.",
  },
  {
    label: "Approved",
    value: 1,
    className: "approved",
    message:
      "The workshop has been approved and is now pending coordination before publishing. The team will handle content finalization, scheduling, and preparation for launch.",
    messageAr:
      "تمت الموافقة على ورشتك بنجاح! سيقوم فريقنا بالتواصل معك قريبًا لاستكمال الترتيبات النهائية، كاختيار الموعد، وضبط المحتوى، وتجهيز المواد اللازمة تمهيدًا لنشر الورشة.",
  },
  {
    label: "Published",
    value: 2,
    className: "published",
    message:
      "Your workshop has been successfully published on the app! You can now track participant numbers, access their details, and download the invoice.",
    messageAr:
      "تم نشر ورشتك على التطبيق بنجاح! يمكنك الآن متابعة عدد المشتركين، والاطّلاع على بياناتهم، وتحميل الفاتورة.",
  },
  {
    label: "Rejected",
    value: 3,
    className: "rejected",
    message:
      "The workshop did not pass the review process. It did not meet the current standards and was rejected. The user may revise and submit a new one in the future.",
    messageAr:
      "نأسف، لم يتم قبول ورشتك نظرًا لعدم توافقها مع المعايير المعتمدة في الوقت الحالي. نُقدّر سعيك وحرصك، ونشجّعك على تطوير الورشة أو التقدّم بورشة جديدة في وقت لاحق.",
  },
  {
    label: "Completed",
    value: 4,
    className: "completed",
    message:
      "Your workshop has been successfully completed. You can now view the full report, which includes the invoice, number of participants, their ratings, and feedback. You may also duplicate and resubmit the same workshop if you wish.",
    messageAr:
      "لقد أُنجزت ورشتك بنجاح. بإمكانك الآن عرض التقرير الكامل الذي يتضمّن الفاتورة، عدد المشاركين، تقييماتهم، وتعليقاتهم. كما يمكنك إعادة تقديم الورشة نفسها إن رغبت.",
  },
  {
    label: "Delayed",
    value: 5,
    className: "delayed",
    message:
      "The workshop request has been delayed, but is still under review by the team. This stage involves evaluating the content to ensure it meets platform standards.",
    messageAr:
      "تم تأجيل طلب الورشة، ولكنه لا يزال قيد المراجعة من قبل الفريق. تتضمن هذه المرحلة تقييم المحتوى لضمان استيفائه لمعايير المنصة.",
  },
];

const statusOptions = [
  { name: "All", value: -1 },
  { name: "Active", value: 1 },
  { name: "Deactive", value: 0 },
];
const demoRequestStatusOptions = [
  { name: "All", value: "all" },
  { name: "Pending", value: "pending", className: "approved" },
  { name: "Contacted", value: "contacted", className: "under_review" },
  { name: "Completed", value: "completed", className: "published" },
];

const platformOptions = [
  { name: "All", value: "all" },
  { name: "iOS", value: "iOS" },
  { name: "Android", value: "android" },
];

const apiLogsStatusOptions = [
  { name: "All", value: -1 },
  { name: "Success", value: 1 },
  { name: "Failure", value: 0 },
];

const apiUrls = [
  {
    name: "Create New Booking",
    value: "/api/v1/customers/booking/createNewBooking",
  },
  {
    name: "Capture Payment",
    value: "/api/v1/customers/booking/capturePayment",
  },
  { name: "Cancel Booking", value: "/api/v1/customers/booking/cancelBooking" },
  {
    name: "Apply Coupon Code",
    value: "/api/v1/customers/booking/applyCouponCode",
  },
  { name: "Apply Wallet", value: "/api/v1/customers/booking/applyWallet" },
  {
    name: "Complete Booking",
    value: "/api/v1/customers/booking/completeBooking",
  },
  {
    name: "Generate Apple Token",
    value: "/api/v1/customers/payment/generateAppleToken",
  },
  {
    name: "New Workshop Request",
    value: "/api/v1/customers/workshop-requests/createNew",
  },
  {
    name: "Register",
    value: "/api/v1/customers/account/profile/register",
  },
  {
    name: "Tap Refunds",
    value: "https://api.tap.company/v2/refunds",
  },
  {
    name: "Tap Charges",
    value: "https://api.tap.company/v2/charges",
  },
  {
    name: "Tap Tokens",
    value: "https://api.tap.company/v2/tokens",
  },
];

const apiLogsResponseOptions = [
  { name: "All", value: 0 },
  { name: "Status Code 200", value: 200 },
  { name: "Status Code 400", value: 400 },
];

const orderByOptions = [
  { name: "Ascending", value: 1 },
  { name: "Descending", value: -1 },
];

const closureTypes = [
  { name: "One Time", value: 1 },
  { name: "Recurring", value: 2 },
];

const orderStatusTypes = [
  {
    name: "Pending",
    value: 0,
    class: "pending_status",
  },
  {
    name: "Booked",
    value: 1,
    class: "booked_status",
  },
  {
    name: "Cancelled",
    value: 2,
    class: "cancelled_status",
  },
  {
    name: "Cancelled & Refund",
    value: 3,
    class: "refund_status",
  },
  {
    name: "Completed ",
    value: 4,
    class: "completed_status",
  },
];

const bookingTypes = [
  {
    name: "Day",
    value: "day",
  },
  {
    name: "Plan",
    value: "plan",
  },
];

const workShopStatusTypes = [
  {
    name: "Available/Draft",
    value: -1,
  },
  {
    name: "Unavailable ",
    value: 4,
  },
  {
    name: "Archive",
    value: 5,
    class: "cancelled_status",
  },
];

const notificationTypes = [
  {
    name: "Broadcast",
    value: "all",
  },
  {
    name: "Customer Role",
    value: "customer_type",
  },
  {
    name: "Last Booking",
    value: "last_booking",
  },
  {
    name: "Number of Bookings",
    value: "number_of_bookings",
  },
  {
    name: "Number of Workshop Bookings",
    value: "number_of_workshop_booked",
  },
  {
    name: "Specific Customers",
    value: "specific_customers",
  },
];
const couponsStatus = [
  { name: "Active", value: 1, className: "active_status" },
  { name: "Deactived", value: 0, className: "inactive_status" },
];
const subscriptionsStatus = [
  { name: "Pending", value: 0, className: "in_progress" },
  { name: "Paid", value: 1, className: "paid" },
  { name: "Unpaid", value: 2, className: "unpaid" },
];
export {
  workshopRequestStatus,
  statusOptions,
  orderByOptions,
  closureTypes,
  orderStatusTypes,
  apiLogsStatusOptions,
  apiLogsResponseOptions,
  apiUrls,
  platformOptions,
  workShopStatusTypes,
  notificationTypes,
  bookingTypes,
  couponsStatus,
  subscriptionsStatus,
  demoRequestStatusOptions,
};
